'use strict'

const STATUS_DISPLAY = {
  ok: { label: 'OK', color: 'success', icon: 'far fa-battery-full' },
  low: { label: 'Low', color: 'error', icon: 'far fa-battery-quarter' },
  not_detected: { label: 'Not detected', color: 'warning', icon: 'far fa-exclamation-triangle' },
  unknown: { label: 'Unknown', color: 'grey', icon: 'far fa-battery-empty' }
}

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

function toDate (value) {
  if (!value) return null
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return null
  return date
}

function agePhrase (date, now) {
  const elapsed = now.getTime() - date.getTime()
  if (elapsed < 60000) return 'just now'

  const minutes = Math.floor(elapsed / 60000)
  if (minutes < 60) return minutes === 1 ? '1 minute ago' : minutes + ' minutes ago'

  const hours = Math.floor(minutes / 60)
  if (hours < 48) return hours === 1 ? '1 hour ago' : hours + ' hours ago'

  const days = Math.floor(hours / 24)
  return days === 1 ? '1 day ago' : days + ' days ago'
}

function shortDate (date) {
  return MONTHS[date.getUTCMonth()] + ' ' + date.getUTCDate()
}

function batterySentence (metadata, health, now) {
  if (typeof metadata.battery_pct !== 'number') {
    return health ? '' : 'Battery reading age unknown.'
  }

  const readAt = health ? toDate(health.batteryReadAt) : null
  if (!readAt) return 'Battery ' + metadata.battery_pct + '%, reading age unknown.'
  return 'Battery ' + metadata.battery_pct + '%, read ' + agePhrase(readAt, now) + '.'
}

function describeBeaconHealth (metadata, now) {
  if (!metadata || typeof metadata !== 'object') return null

  const health = metadata.beaconHealth && typeof metadata.beaconHealth === 'object' ? metadata.beaconHealth : null
  const measuredLow = metadata.battery_low === true ? true : (metadata.battery_low === false ? false : null)
  let status = health && health.status ? health.status : null

  if (!status && measuredLow !== null) status = measuredLow ? 'low' : 'ok'
  if (!status || !STATUS_DISPLAY[status]) return null

  const clock = toDate(now) || new Date()
  const display = STATUS_DISPLAY[status]
  const parts = []
  const batteryText = batterySentence(metadata, health, clock)
  if (batteryText) parts.push(batteryText)

  const heardAt = health ? toDate(health.lastRadioSeenAt) : null
  if (heardAt) parts.push('Last heard by a bus ' + shortDate(heardAt) + '.')

  if (status === 'not_detected') {
    const rides = health && health.unheardRideCount ? health.unheardRideCount : 2
    parts.push('Not heard by the bus on the last ' + rides + ' rides. The battery may be dead; replace the battery or the tag.')
  }

  return {
    status: status,
    label: display.label,
    color: display.color,
    icon: display.icon,
    detail: parts.join(' ')
  }
}

module.exports = {
  describeBeaconHealth: describeBeaconHealth
}
